import {TimelineLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborSymbol} from "./PearlHarborSymbol";
import {ISymbolData} from "../server/PearlHarborModel";
import {PearlHarborHelper} from "../utils/PearlHarborHelper";

export class PearlHarborScatterSymbol extends PearlHarborSymbol {
    private _isSpent: boolean;
    private _featureBuyCover: PIXI.Sprite;

    constructor(symbolData: ISymbolData) {
        super(symbolData);
        this._isSpent = false;
    }

    public playScatterWinAnim(): TimelineLite {
        if (!this._idleAnimation) {
            this._idleAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`scatter${this.isSplit ? "_h" : ""}`));
        }
        this._idleAnimation.state.setEmptyAnimation(0,0);
        this._idleAnimation.state.clearTrack(0);
        this._isSpent = true;
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this.addChild(this._idleAnimation);
                this.addChild(this._sizeMultiplier);
                this._idleAnimation.position.set(0, 0);
                this.currentStateSprite.visible = false;
                this._idleAnimation.name = "trigger2";
            },
            new SpineTween(this._idleAnimation, 0, `trigger2`, 2),
            PearlHarbor.allReelsView.mainReelModels[this._reelId].reelView.scatterMultiplierShineFlyAnimation(this)
        ])

        return tl;
    }

    public playScatterTriggerAnim(isRestore: boolean = false): TimelineLite {
        if (!this._idleAnimation) {
            this._idleAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`scatter${this.isSplit ? "_h" : ""}`));
        }
        this._idleAnimation.state.clearTracks();
        this._idleAnimation.skeleton.setSlotsToSetupPose();
        this._idleAnimation.skeleton.setToSetupPose();
        const tl: TimelineLite = new TimelineLite();
        if (PearlHarbor.model.isRestore) {
            this.addChild(this._idleAnimation);
            this.addChild(this._sizeMultiplier);
            this._idleAnimation.position.set(0, 0);
            this._idleAnimation.name = "loop";
            this._idleAnimation.state.setAnimation(0, "loop", false);
            this.currentStateSprite.visible = false;
            return tl;
        }
        tl.add([
            () => {
                this.addChild(this._idleAnimation);
                this.addChild(this._sizeMultiplier);
                this._idleAnimation.position.set(0, 0);
                this.currentStateSprite.visible = false;
                this._idleAnimation.name = "trigger2";
            },
            new SpineTween(this._idleAnimation, 0, `trigger2`)
        ]).add(()=>{
            if(!this._isSpent){
                this._idleAnimation.name = "loop";
                this._idleAnimation.state.setAnimation(0, "loop", true);
            }
            });

        return tl;
    }

    public playScatterOutsideIdleAnim(): TimelineLite {
        const isActive: boolean = PearlHarborHelper.isActiveCell(this._reelId, this._reelTargetPosition);
        if (PearlHarbor.model.data.wasFeatureBuy) {
            PearlHarborSoundManager.playScatterLandingSound(isActive);
            return new TimelineLite();
        }
        if (this._idleAnimation) {
            this._idleAnimation.destroy();
        }
        this._idleAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`scatter${this._isSplit ? "_h" : ""}`));
        this.addChild(this._idleAnimation);
        const spineObj: PIXI.spine.Spine = this._idleAnimation;
        spineObj.position.set(0, 0);
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => {
                PearlHarborSoundManager.playScatterLandingSound(isActive, (this._reelId === 3 && this._reelTargetPosition === 6));
                this._currentStateSprite.visible = false;
            },
            new SpineTween(spineObj, 0, `land`)
        ])

        tl.add(() => {
            this._currentStateSprite.visible = true;
            this.removeChild(spineObj);
        });
        this.addChild(this._sizeMultiplier);
        if (PearlHarbor.foregroundElements.boostedBet) {
            if (PearlHarbor.model.buyFeatureScatters.indexOf(this.reelId * 14 + this._reelTargetPosition) > -1) {
                PearlHarbor.foregroundElements.stopBoostAnimation(this.reelId * 14 + this._reelTargetPosition);
            }
        }
        PearlHarbor.allReelsView.landingTLs.push(tl);
        return tl;
    }

    public removeBoostCover(): void {
        if (this._featureBuyCover) {
            this.removeChild(this._featureBuyCover);
        }
    }

    public playScatterAnticipationAnim(): void {
        if (!this._idleAnimation) {
            this._idleAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`scatter${this.isSplit ? "_h" : ""}`));
        }
        this.addChild(this._idleAnimation);
        this.addChild(this._sizeMultiplier);
        this._idleAnimation.position.set(0, 0);
        this._idleAnimation.name = "trigger";
        this._idleAnimation.state.setAnimation(0, "trigger", false);
    }

    public stopScatterAnticipationAnim(): void {
        this.currentStateSprite.visible = true;
        if (this._idleAnimation) {
            this._idleAnimation.state.setEmptyAnimation(0, 0);
        }
    }

    public remove() {
        if(this._idleAnimation){
            this._idleAnimation.destroy();
        }
        super.remove();
    }
}